import React from "react";
import { Link } from "react-router-dom";

const ThemeSettings = () => {
  

  return (
    <>
      <div className="sidebar-contact ">
        
      </div>
      
    </>
  );
};

export default ThemeSettings;
